var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7547 26.9102H27.5156V29.9007H30.7547V26.9102Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4852 26.9102H9.24609V29.9007H12.4852V26.9102Z",
    fill: "#EACB30"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0754 5.45312L9.40023 15.1502C9.3517 15.1943 9.31292 15.2481 9.28637 15.308C9.25983 15.368 9.24611 15.4329 9.24609 15.4985V23.8417C9.24608 23.8432 9.24637 23.8448 9.24697 23.8463C9.24756 23.8478 9.24845 23.8491 9.24956 23.8502C9.25068 23.8514 9.25201 23.8523 9.25347 23.8529C9.25494 23.8535 9.25651 23.8538 9.25809 23.8538H14.4194V29.9006H25.4728V26.9875C25.4728 26.967 25.4646 26.9473 25.4501 26.9327C25.4356 26.9182 25.4158 26.9101 25.3953 26.9101H17.6584V23.8538H25.4728V20.8633H17.6584V18.1685H25.4728V15.2331C25.4728 15.2259 25.4713 15.2187 25.4686 15.212C25.4658 15.2053 25.4617 15.1992 25.4566 15.194C25.4514 15.1889 25.4453 15.1849 25.4386 15.1821C25.4319 15.1793 25.4247 15.1779 25.4174 15.1779H14.4192V20.8633H12.4849V16.5443L20.0753 9.64913L27.5153 16.4077V23.8538H30.7544V15.3122C30.7544 15.2623 30.7439 15.213 30.7238 15.1674C30.7036 15.1218 30.6741 15.0809 30.6372 15.0474L20.0754 5.45312Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandLogo);
export default __webpack_public_path__ + "static/media/brand_logo.46dff29d84348aa2f5ea451a5b65dc65.svg";
export { ForwardRef as ReactComponent };